module.exports = __webpack_public_path__ + "media/img/private-venue/calendar-e4eff8d18f7ade1aac3429d45d389eb0.svg";